import React from "react";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { Provider as ReduxProvider } from "react-redux";
import theme from "./theme";
import AppRouter from "./router/AppRouter";

export const Root = ({ history, store }) => (
  <ReduxProvider store={store}>
    <MuiThemeProvider theme={theme}>
      <AppRouter history={history} />
    </MuiThemeProvider>
  </ReduxProvider>
);
Root.displayName = "Root";

export default Root;
